import createTypes from 'redux-create-action-types';

export default createTypes('GET_PACKAGES');
